<div class="sumario-html" aria-label="Filtros do sumário da publicação">
  @if (!caderno.grupos.length && !caderno.secoes.length) {
    <p class="sumario-status">Nenhuma publicação disponível.</p>
  } @else {
    @if (possuiGrupos) {
      <label class="sumario-campo" [for]="'sumario-grupo-' + caderno.cadernoEdicaoId">
        <span>{{ rotuloGrupo }}</span>
        <span class="sumario-select-container">
          <select
            [id]="'sumario-grupo-' + caderno.cadernoEdicaoId"
            [value]="grupoSelecionado?.id ?? ''"
            (change)="selecionarGrupo($event)">
            <option value="">Selecione todos</option>
            @for (grupo of caderno.grupos; track grupo.id) {
              <option [value]="grupo.id">{{ grupo.nome }}</option>
            }
          </select>
          <i class="fas fa-chevron-down" aria-hidden="true"></i>
        </span>
      </label>
    }

    <label class="sumario-campo" [for]="'sumario-secao-' + caderno.cadernoEdicaoId">
      <span>Seção:</span>
      <span class="sumario-select-container">
        <select
          [id]="'sumario-secao-' + caderno.cadernoEdicaoId"
          [disabled]="possuiGrupos && !grupoSelecionado"
          [value]="secaoSelecionadaId ?? ''"
          (change)="selecionarSecao($event)">
          <option value="">Selecione todas</option>
          @for (secao of secoesDisponiveis; track secao.id) {
            <option [value]="secao.id">{{ secao.nome }}</option>
          }
        </select>
        <i class="fas fa-chevron-down" aria-hidden="true"></i>
      </span>
    </label>
  }
</div>
